import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { deleteTicketAction } from 'src/redux/actions/ticketActions';
import { closeDialog } from 'src/redux/actions/dialogActions';

const DeleteTicketDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteTicket]) {
        return state.dialog[DIALOGS.deleteTicket];
      }
      return { opened: false, payload: null };
    });
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteTicket }));
  };

  const handleOk = () => {
    const { ticketId } = payload;
    dispatch(deleteTicketAction(ticketId));
    dispatch(closeDialog({ dialog: DIALOGS.deleteTicket }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-ticket"
      open={opened}>
      <DialogTitle id="deleting-ticket">{t(lang, 'menus.deleting_ticket')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_ticket_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTicketDialog;
